import type { SherwinWilliamsSectionType } from '@paintscout/util/builder'
import createPartnerSectionModule from './createPartnerSectionModule'

// Sherwin Williams (v1 modules, reused 1:1 — see createPartnerSectionModule)
import ColorHelp from '../../../presentation/sections/partners/SherwinWilliams/ColorHelp'
import ColorSamples from '../../../presentation/sections/partners/SherwinWilliams/ColorSamples'
import PopularColors from '../../../presentation/sections/partners/SherwinWilliams/PopularColors'
import ColorOfTheYear from '../../../presentation/sections/partners/SherwinWilliams/ColorOfTheYear'
import TopColors from '../../../presentation/sections/partners/SherwinWilliams/TopColors'
import FinestWhitesNeutrals from '../../../presentation/sections/partners/SherwinWilliams/FinestWhitesNeutrals'
import ExpertCollections from '../../../presentation/sections/partners/SherwinWilliams/ExpertCollections'
import ExploreExterior from '../../../presentation/sections/partners/SherwinWilliams/ExploreExterior'
import ChipsToDoor from '../../../presentation/sections/partners/SherwinWilliams/ChipsToDoor'
import HottestColors from '../../../presentation/sections/partners/SherwinWilliams/HottestColors'
import FinestWhites from '../../../presentation/sections/partners/SherwinWilliams/FinestWhites'
import PeelNStick from '../../../presentation/sections/partners/SherwinWilliams/PeelNStick'
import MatchAPhoto from '../../../presentation/sections/partners/SherwinWilliams/MatchAPhoto'
import ScheduleConsultation from '../../../presentation/sections/partners/SherwinWilliams/ScheduleConsultation'
import UploadPhotos from '../../../presentation/sections/partners/SherwinWilliams/UploadPhotos'
import ColorVisualizer from '../../../presentation/sections/partners/SherwinWilliams/ColorVisualizer'
import ColorExpert from '../../../presentation/sections/partners/SherwinWilliams/ColorExpert'
import SampleColors from '../../../presentation/sections/partners/SherwinWilliams/SampleColors'
import DesignerColorCollection from '../../../presentation/sections/partners/SherwinWilliams/DesignerColorCollection'
import ColormixForecast from '../../../presentation/sections/partners/SherwinWilliams/ColormixForecast'

/**
 * v2 registrations for the Sherwin-Williams partner-content sections (#21311).
 * Keyed by `SherwinWilliamsSectionType` (the canonical list in
 * `@paintscout/util/.../sherwin-williams-section-types.ts`), so adding a type there without a
 * component registration here is a compile error. Every SW type is covered so that legacy docs
 * and v1→v2 converted docs all render in v2. Benjamin Moore (`benjamin-moore-main`) is
 * deliberately excluded — it's stale/unused and stays v1-only.
 */
const partnerSections: Record<SherwinWilliamsSectionType, ReturnType<typeof createPartnerSectionModule>> = {
  'sherwin-williams-popular-colors': createPartnerSectionModule(PopularColors),
  'sherwin-williams-color-of-the-year': createPartnerSectionModule(ColorOfTheYear),
  'sherwin-williams-top-colors': createPartnerSectionModule(TopColors),
  'sherwin-williams-finest-whites-neutrals': createPartnerSectionModule(FinestWhitesNeutrals),
  'sherwin-williams-expert-collections': createPartnerSectionModule(ExpertCollections),
  'sherwin-williams-explore-exterior': createPartnerSectionModule(ExploreExterior),
  'sherwin-williams-color-samples': createPartnerSectionModule(ColorSamples),
  'sherwin-williams-chips-to-door': createPartnerSectionModule(ChipsToDoor),
  'sherwin-williams-hottest-colors': createPartnerSectionModule(HottestColors),
  'sherwin-williams-finest-whites': createPartnerSectionModule(FinestWhites),
  'sherwin-williams-peel-n-stick': createPartnerSectionModule(PeelNStick),
  'sherwin-williams-color-help': createPartnerSectionModule(ColorHelp),
  'sherwin-williams-upload-photo': createPartnerSectionModule(UploadPhotos),
  'sherwin-williams-schedule-consultation': createPartnerSectionModule(ScheduleConsultation),
  'sherwin-williams-match-a-photo': createPartnerSectionModule(MatchAPhoto),
  'sherwin-williams-paint-color-visualizer': createPartnerSectionModule(ColorVisualizer),
  'sherwin-williams-color-expert': createPartnerSectionModule(ColorExpert),
  'sherwin-williams-sample-colors': createPartnerSectionModule(SampleColors),
  'sherwin-williams-designer-color-collection': createPartnerSectionModule(DesignerColorCollection),
  'sherwin-williams-colormix-forecast': createPartnerSectionModule(ColormixForecast)
}

export default partnerSections
